import {Checkbox, FormGroup, Paper, TextField, Typography, FormControlLabel, Button, FormControl, Select, InputLabel, MenuItem} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { useState, useEffect} from "react";
import { useLocation } from "react-router-dom";
import { fetchCustomers, addCustomer, fetchLeadbyId, fetchEmployees, fetchCustomerbyNumber, fetchtodaycust } from "../api/customerapi";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import footer from "../footer.PNG";
import footer2 from "../footer2.PNG";
import header2 from "../header2.png";

const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(60),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    headertext: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    formgroup: {
        justifyContent: "center",   
    },
    textArea: {
        marginLeft: theme.spacing(12),
        marginRight: theme.spacing(14),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(15),
        height: theme.spacing(6),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
      input: {
        "&:invalid": {
          border: "red solid 2px"
        }
      },
      column: {
    marginLeft: 50,
    width: 325,
  },
  }))

const HotelVoucher = () => {
    
     const classes = useStyles();
     const location = useLocation();
      const receivedData = location.state?.tripData || null;
      const [tripData, settripData] = useState(receivedData);   
      const [hotel, sethotel] = useState("");  
      const [input, setinput] = useState({confirmation:"",name:"", checkin:"",duration:"", rt:""}); 
     useEffect(() => {
        console.log("Received object:", receivedData);
  }, [receivedData]);
    console.log(tripData)
    const getvoucher=()=>{
        let x=window.prompt("Enter confirmation number:")
        let adt=window.prompt("Enter number of adults:")
        let chd=window.prompt("Enter number of child:")
        let name=window.prompt("Enter name:")
        let sd=window.prompt("Check In date:")
        let duration=window.prompt("Duration:")
        let roomtype=window.prompt("Room Type:")
        let mealplan=window.prompt("Meal Plan:")
        setinput({confirmation:x,name:name, checkin:sd,duration:duration, rt:roomtype, adt:adt, chd:chd, mp:mealplan})
        savepdf3()
    }

    const savepdf3 = () => {
        let options = {
          orientation: "p",
          unit: "mm",
          format: "a4",
          //putOnlyUsedFonts: true,
        };
        //default is width 210, height 297
        let pdf = new jsPDF(options);
        var width = pdf.internal.pageSize.getWidth();
    
        const header = document.getElementById("imgheader");
        html2canvas(header).then((canvas) => {
          const imgHeader = canvas.toDataURL("image/jpeg", 0.5);
          const footer = document.getElementById("imgfooter");
          html2canvas(footer).then((canvas) => {
            const imgFooter = canvas.toDataURL("image/jpeg", 0.5);
            const footer2 = document.getElementById("imgfooter2");
            html2canvas(footer2).then((canvas) => {
              const imgFooter2 = canvas.toDataURL("image/jpeg", 0.5);
              const initial = document.getElementById("1header");
              html2canvas(initial).then((canvas) => {
                const initialdata = canvas.toDataURL("image/jpeg", 0.5);
                
                  // const imgProps1= pdf.getImageProperties(imgHeader);
                  // const pdfHeight1 = (imgProps1.height * width) / imgProps1.width;
                  pdf.addImage(imgHeader, "JPEG", 0, 0);
                  pdf.addImage(initialdata, "JPEG", 0, 45);
                  pdf.addImage(imgFooter2, "JPEG", 0, 280);
                  //count++
                    pdf.save(
                        hotel +
                          "_" +
                          input.name
                      );
                 
               
              });
            });
          });
        });
        // });
      };
    
 return (  
        <Paper variant="outlined" className={classes.paper} elevation={10}>
            {tripData && "booking" in tripData && "hotellist" in tripData.booking && tripData.booking.hotellist.length>0?(
                <div>
                    <FormControl
                                        style={{
                                          minWidth: 240,
                                          marginTop: 16,
                                          marginRight: 32,
                                          marginLeft: 8,
                                        }}
                                      >
                                        <InputLabel id="hotel">Select Hotel</InputLabel>
                                        <Select
                                          className={classes.textField4}
                                          labelId="hotel"
                                          value={hotel}
                                          onChange={(e) => sethotel(e.target.value)}
                                          
                                        >
                                        {tripData.booking.hotellist.map(h=>
                                          <MenuItem value={h.name}>{h.name}</MenuItem>
                                         )}
                                        </Select>
                                      </FormControl>
                                      <Button
           onClick={getvoucher}
            variant="contained"
           
            color="inherit"
            className={classes.smallbutton2}
          >
            Go
          </Button>
                </div>
            ):("Nothing to display")}
            
            <div id="1header">
                   
                    <p className={classes.para}>
                     <div class="col" className={classes.column}>
                      <Typography className={classes.texttypo2}>
                        <b>Trip Id:</b>
                        <Typography display="inline" className={classes.texttypo}>
                          {" "}
                          {tripData.trip_id}
                        </Typography>
                      </Typography>
                      </div>
                    </p>
            
                  
                        <p>
                          <div class="col" className={classes.column}>
                            <Typography className={classes.texttypo2}>
                              <b>Name: </b>
                              <Typography display="inline" className={classes.texttypo}>
                                {" "}
                                {input.name}
                              </Typography>
                            </Typography>
                          </div>
                        </p>
                       
                     
                        
                        <p>
                          <div class="col" className={classes.column}>
                            <Typography className={classes.texttypo2}>
                              <b>Pax: </b>
                              <Typography display="inline" className={classes.texttypo}>
                                {" "}
                                {input.adt} adults + {input.chd}{" "}
                                children
                              </Typography>
                            </Typography>
                          </div>
                        </p>
                         <p>
                          <div class="col" className={classes.column}>
                            <Typography className={classes.texttypo2}>
                              <b>Hotel Name: </b>
                              <Typography display="inline" className={classes.texttypo}>
                                {" "}
                                {hotel}
                              </Typography>
                            </Typography>
                          </div>
                        </p>
                        <p>
                          <div class="col" className={classes.column}>
                            <Typography className={classes.texttypo2}>
                              <b>Check In Date: </b>
                              <Typography display="inline" className={classes.texttypo}>
                                {" "}
                                {input.checkin}
                              </Typography>
                            </Typography>
                          </div>
                        </p>
                         <p>
                          <div class="col" className={classes.column}>
                            <Typography className={classes.texttypo2}>
                              <b>Duration: </b>
                              <Typography display="inline" className={classes.texttypo}>
                                {" "}
                                {input.duration}
                              </Typography>
                            </Typography>
                          </div>
                        </p>
                         <p>
                          <div class="col" className={classes.column}>
                            <Typography className={classes.texttypo2}>
                              <b>Room Type: </b>
                              <Typography display="inline" className={classes.texttypo}>
                                {" "}
                                {input.rt}
                              </Typography>
                            </Typography>
                          </div>
                        </p>
                         <p>
                          <div class="col" className={classes.column}>
                            <Typography className={classes.texttypo2}>
                              <b>Meal Plan: </b>
                              <Typography display="inline" className={classes.texttypo}>
                                {" "}
                                {input.mp}
                              </Typography>
                            </Typography>
                          </div>
                        </p>
                        {"confirmation" in input && input.confirmation.length>0?(
                            <p>
                          <div class="col" className={classes.column}>
                            <Typography className={classes.texttypo2}>
                              <b>Confirmation Number: </b>
                              <Typography display="inline" className={classes.texttypo}>
                                {" "}
                                {input.confirmation}
                              </Typography>
                            </Typography>
                          </div>
                        </p>
                        ):("")}
                         
                      
                    
                    <br></br>
                  </div>
                   <div id="imgheader">
                          <img
                            onClick={() => console.log("abc")}
                            src={header2}
                            //src={bali1}
                            width="795"
                            alt="quote header"
                          ></img>
                        </div>
                        <div id="imgfooter">
                                <img src={footer} width="795" alt="quote footer"></img>
                              </div>
                              <div id="imgfooter2">
                                <img src={footer2} width="795" alt="quote footer2"></img>
                              </div>
        </Paper>

)}

export default HotelVoucher;